import { render, staticRenderFns } from "./department-summary.vue?vue&type=template&id=0bbf8603&scoped=true"
import script from "./department-summary.vue?vue&type=script&lang=js"
export * from "./department-summary.vue?vue&type=script&lang=js"
import style0 from "./department-summary.vue?vue&type=style&index=0&id=0bbf8603&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf8603",
  null
  
)

export default component.exports